// Never honoured in production builds: CRA also loads .env, which sets REACT_APP_NO_LOGIN for local dev.
export const DEV_LOGIN_BYPASS = process.env.NODE_ENV !== 'production' && !!process.env.REACT_APP_NO_LOGIN
